import error from './error';
import { cart, lists, userData, userDropdown } from './user';
import { country, missing, sort, status } from './shared';
import { browse, detail, myProducts, search } from './product';
import { delivery, order } from './order';
import { cms, ie, offer, cookie } from './misc';

export default {
  // modules ordered alphabetically
  message: {
    // Errors
    error,
    // Misc
    offer,
    ie,
    cms,
    cookie,
    // Order
    delivery,
    order,
    // Product
    search,
    myProducts,
    browse,
    detail,
    // Shared
    sort,
    country,
    status,
    missing,
    // User
    userDropdown,
    userData,
    lists,
    cart,
  },
};
